<template>
  <div class="autocomplete">
    <input
      class="home-search__fields-keyword"
      :class="inputClass"
      :placeholder="placeholder"
      type="text"
      @input="onChange"
      v-model="search"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
      ref="search"
    />
    <div class="autocomplete-results" v-show="isOpen">
      <div v-show="showLocations">
        <h3 class="autocomplete-results__header">Locations</h3>
        <ul class="autocomplete-results__list mb-8">
          <li
            class="autocomplete-result justify-content-start"
            v-if="villageLocationResults.length === 0 && restHomesLocationResults.length === 0"
          >
            No results
          </li>
          <li
            v-else
            v-for="(result, i) in villageLocationResults"
            :key="`village_${i}`"
            @click="setResult(result)"
            class="autocomplete-result autocomplete-result--location"
            :class="{ 'is-active': i === arrowCounter }"
          >
            <div class="d-flex flex-row justify-content-between w-100 ml-2">
              <span class="autocomplete-result__name">{{ result.name }}</span>
              <span class="autocomplete-result__type">{{ result.typeName  }}</span>
            </div>
          </li>
          <li
            v-else
            v-for="(result, i) in restHomesLocationResults"
            :key="`rest_homes_${i}`"
            @click="setResult(result)"
            class="autocomplete-result autocomplete-result--location"
            :class="{ 'is-active': i === arrowCounter }"
          >
            <div class="d-flex flex-row justify-content-between w-100 ml-2">
              <span class="autocomplete-result__name">{{ result.name }}</span>
              <span class="autocomplete-result__type">{{ result.typeName  }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div v-show="showProviders">
        <h3 class="autocomplete-results__header" v-show="operatorResults.length > 0">Providers</h3>
        <ul class="autocomplete-results__list mb-8" v-show="operatorResults.length > 0">
          <li
            v-for="(result, i) in operatorResults"
            :key="`provider_${i}`"
            @click="setResult(result)"
            class="autocomplete-result autocomplete-result--home"
            :class="{ 'is-active': i === arrowCounter }"
          >
            <div class="d-flex flex-row justify-content-between w-100 ml-2">
              <span class="autocomplete-result__name">{{ result.name }}</span>
              <span class="autocomplete-result__type">Provider</span>
            </div>
          </li>
        </ul>
      </div>

      <h3 class="autocomplete-results__header" v-show="this.searchType === 'village'">Retirement villages</h3>
      <ul class="autocomplete-results__list" v-show="this.searchType === 'village'">
        <li
          class="autocomplete-result justify-content-start"
          v-if="villageResults.length === 0"
        >
          No results
        </li>
        <li
          v-else
          v-for="(result, i) in villageResults"
          :key="i"
          @click="setResult(result)"
          class="autocomplete-result autocomplete-result--home"
          :class="{ 'is-active': i === arrowCounter }"
        >
          <div class="d-flex flex-row justify-content-between w-100 ml-2">
            <span class="autocomplete-result__name">{{ result.name }}</span>
            <span class="autocomplete-result__type">Retirement Village</span>
          </div>
        </li>
      </ul>


      <h3 class="autocomplete-results__header" v-show="this.searchType === 'restHome'">Rest homes</h3>
      <ul class="autocomplete-results__list" v-show="this.searchType === 'restHome'">
        <li
          class="autocomplete-result justify-content-start"
          v-if="restHomeResults.length === 0"
        >
          No results
        </li>
        <li
          v-else
          v-for="(result, i) in restHomeResults"
          :key="i"
          @click="setResult(result)"
          class="autocomplete-result autocomplete-result--home"
          :class="{ 'is-active': i === arrowCounter }"
        >
          <div class="d-flex flex-row justify-content-between w-100 ml-2">
            <span class="autocomplete-result__name">{{ result.name }}</span>
            <span class="autocomplete-result__type">Rest Home</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

const macronMap = {
  'Ā': 'A', 'ā': 'a',
  'Ē': 'E', 'ē': 'e',
  'Ī': 'I', 'ī': 'i',
  'Ō': 'O', 'ō': 'o',
  'Ū': 'U', 'ū': 'u'
}

export default {
  name: 'SearchAutocomplete',
  props: {
    isAsync: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Search by location or village name',
    },
    searchType: {
      type: String,
      default: 'village',
    },
    showLocations: {
      type: Boolean,
      default: true,
    },
    showProviders: {
      type: Boolean,
      default: true,
    },
    inputClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOpen: false,
      results: [],
      villageLocationResults: [],
      restHomesLocationResults: [],
      villageResults: [],
      restHomeResults: [],
      operatorResults:[],
      search: '',
      isLoading: false,
      arrowCounter: -1,
      items: [],
      searchItem: [],
    };
  },
  watch: {
    items: function (item, oldItem) {
      if (item.length !== oldItem.length) {
        this.results = item;
        this.isLoading = false;
      }
    },
    searchType: function (type, oldType) {
      this.search = '';
      axios
        .get(`/get-search-autocomplete-list?type=${type}`)
        .then(response => (this.items = response.data))
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    axios
      .get(`/get-search-autocomplete-list?type=${this.searchType}`)
      .then(response => (this.items = response.data))
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    replaceMacrons(str) {
      return str.replace(/[ĀāĒēĪīŌōŪū]/g, (match) => macronMap[match]);
    },
    setResult(result) {
      this.search = result.name;
      this.searchItem = result;
      this.isOpen = false;
      this.$refs.search.focus();
      this.$emit('itemSelected', result);
      this.$emit('submitSearch', result);
      this.setLivewireValue(result.id)
    },
    setLivewireValue(value) {
      if (typeof(Livewire) !== 'undefined') {
        let $wire = Livewire.find('rest-home-survey');
        if ($wire !== undefined) {
          $wire.searchSelectedId = value;
        }
      }
    },
    filterResults() {
      const allResults = [
        {name:'villageLocations', items: []},
        {name:'restHomesLocations', items: []},
        {name:'villages', items: []},
        {name:'restHomes', items: []},
        {name:'operators', items: []}
      ];
      let newSuburbItems = {};
      this.results = this.items.filter((item) => {
        const name = this.replaceMacrons(item.name.toLowerCase());
        const result = name.indexOf(this.search.toLowerCase()) > -1;

        if (result) {
          const type = item.type;
          if (type === 'regionVillage' || type === 'districtVillage' || type === 'suburbVillage') {
            allResults[0].items.push(item);
          }

          if (type === 'regionRestHome' || type === 'districtRestHome' || type === 'suburbRestHome') {
            allResults[1].items.push(item);
          }

          if (type === 'village') {
            allResults[2].items.push(item);
          }

          if (type === 'restHome') {
            allResults[3].items.push(item);
          }

          if (type === 'operator') {
            allResults[4].items.push(item);
          }

          if (item.typeName === 'Suburb' && this.search.toLowerCase() === item.name.toLowerCase()) {
            const searchType = this.searchType;
            newSuburbItems = this.items.filter(function (el) {
              return el.type === searchType &&
                el.suburb === item.name;
            });
          }
        }

        return result;
      });

      if (newSuburbItems.length > 0) {
        newSuburbItems.forEach(async (newItem) => {
          if (this.searchType === 'village') {
            allResults[2].items.push(newItem);
          } else if(this.searchType === 'restHome') {
            allResults[3].items.push(newItem);
          }
        });
      }
      this.villageLocationResults = allResults[0].items.slice(0, 10);
      this.restHomesLocationResults = allResults[1].items.slice(0, 10);
      this.villageResults = allResults[2].items.slice(0, 10);
      this.restHomeResults = allResults[3].items.slice(0, 10);
      this.operatorResults = allResults[4].items.slice(0, 10);
    },
    onChange() {
      this.$emit('input', this.search);
      this.$emit('itemSelected', '');
      this.setLivewireValue('');

      if (this.search.length < 3) {
        this.isOpen = false;
        return;
      }

      if (this.isAsync) {
        this.isLoading = true;
      } else {
        this.filterResults();
        this.isOpen = true;
      }
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      if (this.searchItem) {
        this.$emit('submitSearch');
      }

      // this.search = this.results[this.arrowCounter];
      // this.isOpen = false;
      // this.arrowCounter = -1;
    },
  },
};
</script>

<style>
.autocomplete {
  position: relative;
}

.autocomplete-results {
  padding: 20px 0;
  margin: 0;
  max-height: 300px;
  overflow: auto;
  background: #ffffff;
  position: absolute;
  width: 100%;
  top: 55px;
  left: 0;
  border: 1px solid #EAECEE;
  z-index: 2;
}

.autocomplete-results__list {
  margin: 0;
  padding: 0;
}

.autocomplete-results__header {
  margin: 0 0 5px;
  font-weight: 600;
  font-size: 1.3rem;
  line-height: 1.2;
  text-transform: uppercase;
  text-align: left;
  color: #818EA1;
  padding: 0 30px;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 10px 30px;
  margin-left: 0;
  cursor: pointer;
  color: #34495E;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.autocomplete-result::before {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
  content: '';
  vertical-align: baseline;
  height: 14px;
  width: 14px;
}

.autocomplete-result--location::before {
  background-image: url('../icons/map.svg');
}

.autocomplete-result--home::before {
  background-image: url('../icons/home.svg');
}

.autocomplete-result__name {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1.5rem;
  color: #25394C;
  font-style: italic;
}

.autocomplete-result__type {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1.5rem;
  color: #818EA1;
  font-style: italic;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: rgba(215, 241, 228, 0.5);
}
</style>
